<ng-container *transloco="let convert;">
  <div class="modal--action-list" role="dialog" aria-modal="true" aria-labelledby="mark-arrived-modal-title"
    [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.markArrivedModal.ariaLabelMarkArrviedModal')" [attr.data-track-region]="headline">
    <header class="modal__header">
      <h1 class="modal__title" id="mark-arrived-modal-title" tabindex="-1">
        {{ headline }}
      </h1>
    </header>

    <div class="modal__content">
      @if (selectedVehicles.length === 1) {
        <div>
          <span [innerHTML]="convert('sellModule.manageInventory.actionListModal.markArrivedModal.textSelectConfirmVIN', {vinNumberText : vinNumberText(selectedVehicles)})">
          </span>
        </div>
      }
      @if (selectedVehicles.length > 1) {
        <div>
          <span [innerHTML]="convert('sellModule.manageInventory.actionListModal.markArrivedModal.textSelectConfirmVINs', {vinNumberText : vinNumberText(selectedVehicles)})">
          </span>
        </div>
      }
      <div class="modal__actions">
        <button
          class="btn btn-primary me-md-2 mb-3 mb-md-0"
          allytmln="Yes, Mark as Arrived"
          data-track-elem="button"
          data-track-name="Search"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.markArrivedModal.ariaLabelYesMarkArrived')"
          (click)="markVehicleArrived()">
          {{convert('sellModule.manageInventory.actionListModal.markArrivedModal.ariaLabelYesMarkArrived')}}
        </button>
        <button
          class="btn cancel btn-link outline-focus ms-md-2"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.markArrivedModal.ariaLabelNoCancel')"
          (click)="closeModal()">
          <span>{{convert('sellModule.manageInventory.actionListModal.markArrivedModal.ariaLabelNoCancel')}}</span>
        </button>
      </div>
    </div>

    @if (configuration) {
      <button class="modal__close" data-dismiss="modal" [attr.aria-label]="convert('common.modalClose')" (click)="closeModal()"
        data-track-elem="icon" data-track-name="Close" data-track-trigger="close">
        <img src="../../../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
          alt="{{convert('common.altCloseModelIcon')}}" />
      </button>
    }
  </div>
</ng-container>
